<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.createBookBundle')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.createBookBundle')}}</div>
                        <button class="btn btn-primary float-right"
                            @click="saveBookBundle()">{{$t('button.save')}}</button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="DiscriptionField">{{$t('form.book.description')}}<span
                                            class="text-danger">*</span> </label>
                                    <textarea id="DiscriptionField" rows="3" class="form-control"
                                        v-model.trim="$v.bookBundle.Description.$model"
                                        :class="{ 'is-invalid': $v.bookBundle.Description.$error }"></textarea>
                                    <div class="invalid-feedback" v-if="!$v.bookBundle.Description.required">
                                        {{$t('form.validation.required')}}</div>
                                    <div class="invalid-feedback" v-if="!$v.bookBundle.Description.maxLength">
                                        {{$t('form.validation.maxLength', {num: $v.bookBundle.Description.$params.maxLength.max})}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="CreationDateField">{{$t('form.book.creationDate')}}<span
                                            class="text-danger">*</span></label>
                                    <input id="CreationDateField" type="date" class="form-control"
                                        v-model.trim="$v.bookBundle.CreatedOn.$model"
                                        :class="{ 'is-invalid': $v.bookBundle.CreatedOn.$error }">
                                    <div class="invalid-feedback" v-if="!$v.bookBundle.CreatedOn.required">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <hr>

                                <h4>{{$t('form.book.books')}}</h4>

                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>{{$t('form.book.title')}}</th>
                                                <th>{{$t('form.book.author')}}</th>
                                                <th>{{$t('form.book.publisher')}}</th>
                                                <th>{{$t('form.book.edition')}}</th>
                                                <th>{{$t('form.book.ISBN')}}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(book,index) in selectedBooks" :key="index">
                                                <td>{{book.Title}}</td>
                                                <td>{{book.Author}}</td>
                                                <td>{{book.Publisher}}</td>
                                                <td>{{book.Edition}}</td>
                                                <td>{{book.ISBN}}</td>
                                                <td class="text-right">
                                                    <span style="color:red; cursor:pointer" @click="removeBook(index)">
                                                        <i class="fa fa-times"></i>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group shadow p-3">
                                    <label>{{$t('form.book.searchBooks')}}</label>
                                    <ul class="list-group m-0">
                                        <div class="input-group">
                                            <input type="text" class="form-control"
                                                :placeholder="$t('form.book.addBookBundle')" v-model="bookTitle"
                                                @keyup="searchBook">
                                            <div class="input-group-append">
                                                <span class="input-group-text" @click="clear()"
                                                    style="color:red;cursor:pointer;">
                                                    <i class="fa fa-times"></i></span>
                                            </div>
                                        </div>
                                        <li class="list-group-item searchCourseBackground" v-for="(book,index) in books"
                                            v-bind:key="index" @click="addBook(book)" style="cursor:pointer">
                                            {{book.Title}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        required,
        minLength,
        maxLength,

    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                bookTitle: '',

                bookBundle: {
                    Description: null,
                    CreatedOn: moment().format('YYYY-MM-DD'),
                },

                books: [],
                selectedBooks: []
            }
        },

        validations: {
            bookBundle: {
                Description: {
                    required,
                    maxLength: maxLength(255)
                },
                CreatedOn: {
                    required
                }
            }
        },

        mounted() {
            if (!this.permissions.createBookbundles) {
                this.$router.push('/');
                return;
            }
        },

        methods: {

            searchBook() {
                if (this.bookTitle == '') {
                    this.clear();
                    return;
                }

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios
                    .get(`/api/books?title=${this.bookTitle}`, {
                        cancelToken: this.request_source.token
                    }).then(response => {
                        this.books = response.data.data.data;
                    }).catch(error => {
                        console.log('error fetching books');
                    });
            },

            addBook(book) {
                this.selectedBooks.push(book);
                this.clear();
            },

            removeBook(index) {
                this.selectedBooks.splice(index, 1);
            },

            clear() {
                this.books = [];
                this.bookTitle = '';
            },

            async saveBookBundle() {

                this.$v.$touch();

                if (this.$v.$invalid) {
                     let errorMsg = '';
                      if(this.$v.bookBundle.Description.$error){
                            errorMsg = 'Description';
                      }

                    if(this.$v.bookBundle.CreatedOn.$error){
                            errorMsg = errorMsg ? errorMsg +"and  Created On": "Created On";
                      }

                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;

                }

                let data = await this.getBookBundleData();

                this.isLoading = true;

                axios
                    .post('/api/bookbundles', data)
                    .then(response => {

                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'BookBundleIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;

                        console.log('error saving book bundle');
                    });
            },

            getBookBundleData() {
                let books = []
                let bookbundle = {
                    Description: this.bookBundle.Description,
                    CreatedOn: this.bookBundle.CreatedOn,
                }

                this.selectedBooks.forEach(b => books.push(b.ID))

                return {
                    bookbundle,
                    books
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
<style scoped>
    .searchCourseBackground:hover {
        background: #eee;
    }

</style>
